<template>
<div
  class="setting-popup"
  v-show='boxData.judgeBox'
  :style="{
    'top': boxData.fix.y+'px',
    'left': boxData.fix.x+'px',
    'z-index': boxData.Zindex,
  }"
  @mousedown.stop.prevent
>
  <div
    class="setting-popup__drag-area"
    v-on:mousedown="moveStart($event, true)"
    v-on:mousemove="moveArea($event)"
    v-on:mouseup="saveMoveState($event)"
    :style="{'cursor': 'move'}"
  >

      <!-- <transition name="slide-up"
        enter-active-class="slide-up-2"
        leave-active-class="slide-up-2"
        enter-class="slide-up-2-start"
        leave-to-class="slide-up-2-start"
      >
      </transition> -->
      <div v-show="childMode" @click="toggleChildMode(false)" class="btn-back-top">
        <icon url="../../../../static/svg/popups/arrow-left.svg"></icon>
      </div>
      <span>{{`${isOut ? '出场' : '入场'}`}}动画</span>
    </div>
  <div class="setting-popup__content">
    <transition
      name="slide-up"
      leave-to-class="slide-up-1"
      enter-class="slide-up-1"
    >
      <div class="list" v-show="!childMode" v-bar>
        <div>
        <div class="list__wrapper">
          <el-tooltip
            effect="dark"
            placement="top"
            :disabled="!item.disabled"
            v-for="(item, i) in showingItems"
            :key="i"
          >
          <div slot="content" v-html="isDynamicArtText() ? tip2 : tip"></div>
          <div
            class="list__item"
            :class="{
              ['icon-wrapper-' + getIconName(item.alias || item.icon, isOut)]: true,
              'no-anim': item.type === 'None',
              'is-selected': item.selected,
              disabled: item.disabled
            }"
            @click="onClickItem(item)"
          >
            <i :class="{'is-out': boxData.data.effectType === 'exit', ['icon-effect-' + getIconName(item.alias || item.icon, isOut)]: true}"></i>
            <div class="text">{{item.text}}</div>
          </div>
          </el-tooltip>
        </div>
        </div>
      </div>
    </transition>

    <transition name="slide-up"
      enter-active-class="slide-up-2"
      leave-active-class="slide-up-2"
      leave-to-class="slide-up-2-start"
      enter-class="slide-up-2-start"
    >
      <div class="child-effects effect-slide" v-show="childMode">
        <!-- <div class="btn-back" @click="toggleChildMode(false)">
          <i class="icon"><img src="../../../../static/svg/popups/arrow-left.svg" alt=""></i>
          <span style="paddingLeft: 12px;">返回</span>
        </div> -->
        <childEffects
          ref="childEffectsRef"
        ></childEffects>
      </div>
    </transition>
  </div>

  <div class="hand">
    <el-tooltip effect="dark" :content="`添加${isOut ? '出场' : '入场'}手势`" placement="bottom" :open-delay="1000">
      <div class="hand__btn" @click="showHandDialog($event)"
        :class="{disabled: btnHand.disabled}"
      >
        <i class="icon-hand-hand"></i>
        <div class="text">{{`添加${isOut ? '出场' : '入场'}手势`}}</div>
      </div>
    </el-tooltip>
  </div>

  <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup()"></div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../../mixins/popup.vue'
import childEffects from '../effectSetting/childEffects.vue'

export default {
  mixins: [popup],
  components: {
    childEffects,
  },
  data () {
    let inCommon = [
      'None',
      'Slide',
      'LeftIn',
      'RightIn',
      'DownIn',
      'UpIn',
      'PopIn',
      'FadeIn',
      'Smear'
    ];
    let outCommon = [
      'None',
      'Slide',
      'RightOut',
      'LeftOut',
      'UpOut',
      'DownOut',
      'PopOut',
      'FadeOut',
      'Smear'
    ];
    return {
      popupType: 'inOutEffect',
      sprites: [],
      items: {
        in: [
          {text: '无动画', type: 'None', disabled: false, alias: 'noAnim'},

          {text: '书写', type: 'Write', disabled: false, alias: 'write'},
          {text: '逐行显示', type: 'Appear', disabled: false, alias: 'appear'},
          {text: '打字', type: 'Type', disabled: false, alias: 'type'},
          {text: '翻滚', type: 'Roll', disabled: false, alias: 'roll'},
          {text: '弹跳', type: 'Bounce', disabled: false, alias: 'bounce'},

          {text: '手绘', type: 'Hand', disabled: false, alias: 'hand'},
          {text: '涂抹', type: 'Draw', disabled: false, alias: 'write'},

          {text: '移入', type: 'Slide', disabled: false, alias: 'slide'},
          {text: '放大出现', type: 'PopIn', disabled: false, alias: 'pop'},
          {text: '淡入', type: 'FadeIn', disabled: false, alias: 'fade'},
          {text: '擦入', type: 'Smear', disabled: false, alias: 'smear'},
        ],
        out: [
          {text: '无动画', type: 'None', disabled: false, alias: 'noAnim'},
          {text: '移出', type: 'Slide', disabled: false, alias: 'slide'},
          {text: '缩小退出', type: 'PopOut', disabled: false, alias: 'pop'},
          {text: '淡出', type: 'FadeOut', disabled: false, alias: 'fade'},
          {text: '擦出', type: 'Smear', disabled: false, alias: 'smear'},
        ]
      },
      inEffectNames: {
        common: [...inCommon],
        Image: [...inCommon, 'Draw'],
        Svg: [...inCommon, 'Hand', 'Draw'],
        Text: [...inCommon, 'Write', 'Type', 'Appear', 'Roll', 'Bounce'],
        Lottie: [...inCommon],
        Chart: [...inCommon],
        Video: [...inCommon],
        Frame: [...inCommon],
      },
      outEffectNames: {
        common: [...outCommon],
      },
      showingItems: [],
      childMode: false,
      slideRE: /Up(In|Out)|Right(In|Out)|Down(In|Out)|Left(In|Out)/,
      btnHand: {
        disabled: true
      },
      special: [
        'Write',
        'Appear',
        'Type',
        'Roll',
        'Bounce',
        'Hand',
        'Draw'
      ],
      canHand: [
        'Slide', 'Hand', 'Draw', 'Write',
        'LeftIn',
        'RightIn',
        'DownIn',
        'UpIn',
        'RightOut',
        'LeftOut',
        'UpOut',
        'DownOut',
      ],
      tip: '该入场与停留特效不能并存，<br/>请调整试试吧',
      tip2: '该入场与动态艺术字不能并存，<br/>请调整试试吧',
      reports: {
        'None': 'animation_setting_panel,click_ee_ffect_None,动画设置_出入场动画_无动画',
        'Write': 'animation_setting_panel,click_ee_ffect_Write,动画设置_出入场动画_书写',
        'Appear': 'animation_setting_panel,click_ee_ffect_Appear,动画设置_出入场动画_逐行显示',
        'Type': 'animation_setting_panel,click_ee_ffect_Type,动画设置_出入场动画_打字',
        'Roll': 'animation_setting_panel,click_ee_ffect_Roll,动画设置_出入场动画_翻滚',
        'Bounce': 'animation_setting_panel,click_ee_ffect_Bounce,动画设置_出入场动画_弹跳',
        'Hand': 'animation_setting_panel,click_ee_ffect_Hand,动画设置_出入场动画_手绘',
        'Draw': 'animation_setting_panel,click_ee_ffect_Draw,动画设置_出入场动画_涂抹',
        'Slide': 'animation_setting_panel,click_ee_ffect_Slide,动画设置_出入场动画_移入',
        'PopIn': 'animation_setting_panel,click_ee_ffect_PopIn,动画设置_出入场动画_放大出现',
        'FadeIn': 'animation_setting_panel,click_ee_ffect_effectName,动画设置_出入场动画_淡入',
        'Smear': 'animation_setting_panel,click_ee_ffect_Smear,动画设置_出入场动画_擦入',
        'PopOut': 'animation_setting_panel,click_ee_ffect_PopOut,动画设置_出入场动画_缩小退出',
        'FadeOut': 'animation_setting_panel,click_ee_ffect_FadeOut,动画设置_出入场动画_淡出',
      }
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
    ]),
    ...mapGetters({
      storeHand: 'getHand'
    }),
    isOut () {
      return (this.boxData.data || {}).effectType === 'exit'
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.sprites = this.SelectSprites_Msg || [];
          this.childMode = false;
          let type = this.boxData.data.effectType;
          let isOut = type === 'exit';
          this.setInOutView(isOut);
          this.render(isOut);
          this.$nextTick(() => {
            this.setPosition();
          })
        }
      }
    }
  },
  created () {
    this.$bus.on('childEffects.optionChanged', () => {
      // if (!this.sprites || !this.sprites.length) {
      //   this.sprites = this.SelectSprites_Msg || [];
      // }
      if (this.boxData.judgeBox) {
        this.render();
      }
    });
  },
  methods: {
    render (isOut) {
      isOut = isOut === void 0 ? this.isOut : isOut;
      let sprites = this.sprites || [];
      isOut ? this.renderOut(sprites) : this.renderIn(sprites);

      // this.$set(this.btnHand, 'disabled', sprites.length !== 1);
      this.renderBtnHand(sprites, isOut);

      this.renderDisabled();
    },
    renderIn (sprites) {
      let effectName
      let same = sprites.every(s => s.effect.code === sprites[0].effect.code);
      if (same) {
        effectName = sprites[0].effect.code;
      }
      if (this.slideRE.test(effectName)) {
        effectName = 'Slide';
      }

      this.showingItems.map(item => {
        this.$set(item, 'selected', item.type === effectName);
      });

      let disabled = this.canHand.indexOf(effectName) < 0;
        this.$set(this.btnHand, 'disabled', disabled);
    },
    renderOut (sprites) {
      let effectName
      let same = sprites.every(s => s.effect.exitAnim.type === sprites[0].effect.exitAnim.type);
      if (same) {
        effectName = sprites[0].effect.exitAnim.type;
      }
      if (this.slideRE.test(effectName)) {
        effectName = 'Slide';
      }

      this.showingItems.map(item => {
        this.$set(item, 'selected', item.type === effectName);
      });

      let disabled = this.canHand.indexOf(effectName) < 0;
      this.$set(this.btnHand, 'disabled', disabled);
    },
    renderBtnHand (sprites, isOut) {
      if (sprites.length === 1) {
        let sprite = sprites[0];
        let effectName = sprite.effect.code;
        if (isOut) {
          effectName = sprite.effect.exitAnim.type;
        }

        let disabled = this.canHand.indexOf(effectName) < 0;
        this.$set(this.btnHand, 'disabled', disabled);
      }
      // else {
      //   this.$set(this.btnHand, 'disabled', true);
      // }
    },
    setInOutView (isOut) {
      let items = isOut ? this.items.out : this.items.in;
      let sprites = this.sprites || [];
      let names = isOut
        ? this.outEffectNames.common
        : sprites.reduce((memo, s) => {
            let names = this.inEffectNames[s.type] || this.inEffectNames.common;
            if (!memo) {
              return [...names];
            }
            let f = memo.filter(name => names.indexOf(name) > -1);
            return f
          }, null);

      this.showingItems = items.filter(item => names.indexOf(item.type) > -1) || []
    },
    setPosition () {
      let triggerRect = this.boxData.data.rect;
      let rect = triggerRect;
      let x    = this.isOut ? rect.right  - parseInt(this.$el.offsetWidth) : rect.left;
      let y    = rect.top - parseInt(this.$el.offsetHeight) - 40;
      this.$set(this.boxData, 'fix', {
        x,y
      });
      this.$set(this.boxData.data, 'initialX', x)
      this.$set(this.boxData.data, 'initialY', y)
    },
    onClickItem (item) {
      let sprites = this.sprites || [];
      this.$analysis(this.reports[item.type]);
      if (/^(Slide|Smear)$/.test(item.type)) {
        this.toggleChildMode(true, item);
        return;
      }

      sprites.map(s => {
        this.setEffect(item, s);
      });

      this.render();
    },
    setEffect (item, sprite) {
      let inOut = 'in';
      if (this.boxData.data.effectType === 'exit') {
        inOut = 'out';
      }
      let inOutType;
      if (inOut === 'in') {
        let {start, end} = sprite.effect.entranceAnim;
        let handInfo = (item.type === 'Hand' || item.type === 'Draw')
          ? this.storeHand
          : null;
        if (item.type === 'None') {
          start = end;
        } else {
          start = Math.max(end - 500, 0);
        }

        sprite.updateEffect({
          code: item.type,
          entranceAnim: {
            start,
            end,
            hand: handInfo
          }
        }, true);

        inOutType = 'entrance';
      }
      if (inOut === 'out') {
        let {start, end} = sprite.effect.exitAnim;
        if (item.type === 'None') {
          end = start;
        } else {
          if(start >= this.TOOL.selectedScenes.duration) {
            start = this.TOOL.selectedScenes.duration - 500;
          }
          end = Math.min(start + 500, this.TOOL.selectedScenes.duration);
        }
        sprite.updateEffect({
          exitAnim: {
            type: item.type,
            start,
            end
          }
        }, true);

        inOutType = 'exit';
      }

      sprite.effect.init();
      this.$bus.emit('updateEffect_vue', {
        sprite: sprite,
        effect: sprite.effect || {},
        type: inOutType
      });
    },
    toggleChildMode (flag, item) {
      this.childMode = flag;
      if (flag) {
        let inOut = 'in';
        if (this.boxData.data.effectType === 'exit') {
          inOut = 'out';
        }
        let animation = item.type.toLowerCase() || 'slide';
        this.$refs.childEffectsRef.showList({
          inOut,
          animation
        });
      } else {
        this.render();
      }
    },
    getIconName (origin, isOut) {
      let sprites = this.sprites || [];
      let slideMap = {
        LeftIn: 'right',
        RightIn: 'left',
        UpIn: 'down',
        DownIn: 'up',
        LeftOut: 'left',
        RightOut: 'right',
        UpOut: 'up',
        DownOut: 'down'
      };
      if (origin === 'slide') {
        let effectName = '';
        let same = sprites.every(s => s.effect.code === sprites[0].effect.code);
        if (isOut) {
          same = sprites.every(s => s.effect.exitAnim.type === sprites[0].effect.exitAnim.type);
        }
        if (same) {
          effectName = sprites[0].effect.exitAnim.type;
        }
        return slideMap[effectName] || 'left'
      }
      if (origin === 'smear') {
        let direction = '';
        let same = sprites.every(s => s.effect.direction === sprites[0].effect.direction);
        if (isOut) {
          same = sprites.every(s => s.effect.exitAnim.direction === sprites[0].effect.exitAnim.direction);
        }
        if (same) {
          direction = sprites[0].effect.direction;
        }
        return direction ? `smear-${direction}` : 'smear-n';
      }

      return origin
    },
    showHandDialog (ev) {
      if (ev.currentTarget.classList.contains('disabled')) {
        return;
      }

      // 入场是否书写动画
      let modalName = this.sprites[0].effect.code === 'Write' ? 'writehand' : 'hand';

      this.$bus.emit('Modal_vue', {
        name: modalName,
        type: modalName,
        data: {
          inout: this.isOut ? 'out' : 'in',
        }
      });
    },

    hasPathOrStay () {
      return this.sprites.some(sprite => {
        return sprite.effect.pathAnim.target || sprite.effect.stayAnim.type !== 'None'
      });
    },

    isDynamicArtText () {
      return this.sprites.some(sprite => {
        return sprite.type === 'Text' && sprite.artType && sprite.artControl && sprite.artControl.length
      });
    },

    renderDisabled () {
      let shouldDisabled = this.hasPathOrStay() || this.isDynamicArtText();
      let names = this.special;
      let filtered = this.items.in.filter(item => names.indexOf(item.type) > -1) || [];
      filtered.map(item => {
        this.$set(item, 'disabled', shouldDisabled);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../style/_colors.scss";

.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  min-height: 286px;
  max-height: 367px;
  z-index: 35;
  box-shadow: 0 0 3px 1px #d8dee9;
  border-radius: 8px;
  // border: 1px solid #d8dee9;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  color: #474261;
  padding-bottom: 30px;

  &__drag-area {
    line-height: 34px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }

  &__content {
    padding-bottom: 16px;
    overflow: hidden;
  }
}

.list {
  height: 300px;

  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 16px;
    padding-right: 13px;
  }

  &__item {
    margin-top: 12px;
    margin-right: 24px;
    cursor: pointer;
    &:nth-child(3n) {
      margin-right: 0;
    }
    &:nth-child(1), &:nth-child(2), &:nth-child(3) {
      margin-top: 0;
    }
    >i {
      box-sizing: border-box;
      display: inline-block;
      width: 60px;
      height: 58px;
      border-radius: 4px;
      background-color: $c6;
    }

    &.no-anim {
      > i {
        position: relative;
        overflow: hidden;
        &:before {
          content: " ";
          position: absolute;
          height: 1px;
          width: 110px;
          background-color: red;
          transform: rotate(-45deg) translatex(-60px) translatey(-19px);
        }
      }
    }

    &.is-selected {
      >i {
        border: 1px solid $c2;
        box-shadow: 0 0 0 0.5px $c2;
      }
    }
    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
}

.hand {
  position: absolute;
  left: 1px;
  bottom: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 258px;
  background-color: #f0f0f8;

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 258px;
    height: 36px;
    border-radius: 0 0 8px 8px;
    background-color: #f0f0f8;
    cursor: pointer;
    &:hover {
      >i {
        background-image: url(../../../../static/svg/hand-active.svg);
      }
    }
    >i {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 0.6em;
    }

    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
}

.child-effects {
  // padding-top: 12px;
  background-color: #fff;
}

.btn-back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
	height: 34px;
  margin-left: 20px;
  margin-bottom: 10px;
	background-color: #f0f0f8;
	border-radius: 17px;
  cursor: pointer;
}

.btn-back-top {
  display: inline-block;
  cursor: pointer;
  line-height: 1;
  background: #d8dee9;
  text-align: center;
  text-indent: 0;
  transform: translatey(2px);
  margin-right: 7px;
  background-color: transparent;
}

.icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  & > img {
    width: 100%;
    height: 100%;
  }
}

.slide-up-enter-active, .slide-up-leave-active {
  transition-duration: 0.3s;
  position: absolute;
}
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(-30%);
}
.slide-up-1 {
  transform: translateY(-60%);
  opacity: 0.6;
  z-index: -1;
}
.slide-up-2 {
  transition-duration: 1.1s;
}
.slide-up-2-start {
  transform: translateY(30%);
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/inOutEffect/inOutEffect.vue